import React, { useEffect } from 'react';
import { ShieldAlert } from 'lucide-react';
import Header from '../components/Header';
import Button from '../components/elements/Button';
import { useNavigate } from 'react-router-dom';

export default function SessionTimeoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Session Timed Out | Eternal Locker™';
  }, []);

  return (
    <>
      <Header type="small" showAccountDropdown={false} />
      <div className="w-full max-w-3xl mx-auto px-4">
        <div className="bg-card-background border border-accent-main/40 rounded-xl shadow-2xl p-8 sm:p-10 text-center">
          <div className="w-14 h-14 mx-auto rounded-full bg-primary-light flex items-center justify-center mb-5">
            <ShieldAlert className="w-7 h-7 text-accent-main" />
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-primary-dark mb-3">Session Ended</h1>
          <p className="text-text-muted text-base sm:text-lg leading-relaxed">
            Just to be safe, we logged you out.
            <br />
            Log back in to pick up where you left off.
          </p>
          <div className="mt-8">
            <Button type="primary" onClick={() => navigate('/')}>
              Back to Login
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
